import { Link } from "react-router";
import { Button, cn } from "@mindstonehq/ui";
import { ArrowRight, Radio, Sparkles, Star, History } from "lucide-react";
import type { AccessTier } from "~/routes/_app.events_.$slug_.live/types";
import { msg } from "@lingui/core/macro";
import { i18n } from "@lingui/core";

export interface LiveEventCTAState {
  tier: AccessTier;
  slug: string;
}

interface CtaConfig {
  buttonLabel: string;
  href: string;
  Icon: typeof Radio;
}

function configForTier(state: LiveEventCTAState): CtaConfig | null {
  const base = `/events/${encodeURIComponent(state.slug)}/live`;
  switch (state.tier) {
    case "rsvpd_pre_event":
      return {
        buttonLabel: i18n._(msg`Live event hub`),
        href: base,
        Icon: Sparkles,
      };
    case "rsvpd_event_window":
    case "attended_live":
      return { buttonLabel: i18n._(msg`Join live`), href: base, Icon: Radio };
    case "attended_post_event":
      return {
        buttonLabel: i18n._(msg`Ratings & networking`),
        href: `${base}?tab=ratings`,
        Icon: Star,
      };
    case "rsvpd_no_show":
      return { buttonLabel: i18n._(msg`See what happened`), href: base, Icon: History };
    case "not_logged_in":
    case "logged_in_no_rsvp":
    default:
      return null;
  }
}

export function LiveEventCTAButton({
  state,
  className,
}: {
  state: LiveEventCTAState;
  className?: string;
}) {
  const config = configForTier(state);
  if (!config) return null;
  const { Icon } = config;
  return (
    <Button
      asChild
      size="sm"
      variant="default"
      className={cn("flex gap-2", className)}
    >
      <Link to={config.href}>
        <Icon className="h-4 w-4" aria-hidden="true" />
        <span>{config.buttonLabel}</span>
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </Link>
    </Button>
  );
}

// Back-compat alias for any remaining call sites; same shape as the button.
export const LiveEventCTABanner = LiveEventCTAButton;
